<template>
  <!-- start navigator -->
  <div class="container ps-lg-5 pe-lg-5 mt-1">
    <div class="row">
      <div
        class="
          col-12
          d-none d-lg-flex
          justify-content-between
          align-items-center
        "
      >
        <nav style="--bs-breadcrumb-divider: '>'" aria-label="breadcrumb">
          <ol class="breadcrumb">
            <li class="breadcrumb-item">
              <router-link
                class="text-decoration-none router-link"
                to="/AgenteService"
                >หน้าแรก</router-link
              >
            </li>
            <li class="breadcrumb-item">
              <router-link
                class="text-decoration-none router-link"
                to="/ChangeBranch"
                >แจ้งย้ายสาขา</router-link
              >
            </li>
            <li class="breadcrumb-item router-link active">
              ตรวจสอบข้อมูลที่ขอเปลี่ยนแปลง
            </li>
          </ol>
        </nav>
      </div>
    </div>
  </div>
  <!-- end navigator -->
  <div class="container-lg">
    <div class="row">
      <!-- Left Menu -->
      <div class="col-left-menu">
        <div class="left-menu">
          <ul class="d-none d-lg-block">
            <Menu />
          </ul>
        </div>
      </div>
      <!-- Left Menu -->
      <!-- Mobile -->
      <div
        class="
          col-left-menu
          d-flex d-lg-none
          border-bottom
          align-items-center
          border-bottom
          w-100
          pl-3
          pr-3
        "
        style="background-color: #f2f2f2"
      >
        <div class="icon-back">
          <router-link to="/ChangeBranch">
            <img src="@/assets/images/arrow-blue.svg" class="w-100" />
          </router-link>
        </div>
        <div
          class="title ps-md-3 ps-lg-3 d-block d-lg-none text-center w-100"
          style="font-family: DB Heavent; color: #0057a8"
        >
          ตรวจสอบข้อมูลที่ขอเปลี่ยนแปลง
        </div>
      </div>
      <!-- Mobile -->
      <div class="col col-content">
        <div class="d-none d-lg-flex align-items-center border-bottom">
          <div class="icon-back">
            <router-link to="/ChangeBranch">
              <img src="@/assets/images/arrow-blue.svg" class="w-100" />
            </router-link>
          </div>
          <div
            class="
              title
              blue-1
              fw-normal
              ps-md-3
              pe-lg-3
              font-family
              d-none d-md-block d-lg-block
            "
          >
            ตรวจสอบข้อมูลที่ขอเปลี่ยนแปลง
          </div>
        </div>
        <div class="pb-2 pb-lg-2">
          <div class="mt-2 mt-lg-2">
            <div class="blue-1 fs-5 d-lg-inline-block mt-lg-2 font-family">
              ขอย้ายสาขา
              <img src="@/assets/images/checked.svg" class="svg-checked" />
            </div>
          </div>
        </div>
        <div class="pb-2 pb-lg-2">
          <div class="ps-3 mt-2 mt-lg-2">
            <div v-if="this.$store.state.PASS_OFFICE.DETAIL.length > 0" class="gary-3 fs-5 font-family">
              สาขาปัจจุบัน: {{ this.$store.state.PASS_OFFICE.DETAIL[0].BARNCH }}
            </div>
            <div class="gary-3 fs-5 font-family">
              สาขาใหม่: {{ this.$store.state.PASS_OFFICE.OFFICE }}
            </div>
            <div class="gary-3 fs-5 font-family">วัตถุประสงค์ของการขอย้าย:</div>
            <div class="gary-3 fs-5 font-family">
              {{ this.$store.state.PASS_OFFICE.MEMO }}
            </div>
          </div>
        </div>
        <div class="pb-2 pb-lg-2">
          <div class="ps-3 mt-2 mt-lg-2">
            <div class="blue-1 fs-5 font-family">
              กรุณาตรวจสอบข้อมูลที่ขอแก้ไขก่อนกดปุ่ม ส่งข้อมูล
            </div>
          </div>
        </div>

        <div class="row mb-3 mt-2">
          <div class="col-6 col-lg-6">
            <button
              type="button"
              class="btn btn-light btn-cancel font-family d-inline-block"
              data-bs-toggle="modal"
              data-bs-target="#exampleModal"
            >
              ยกเลิก
            </button>
          </div>
          <div class="col-6 col-lg-6 text-right">
            <button
              type="button"
              class="btn btn-continue font-family d-inline-block"
              data-bs-toggle="modal"
              data-bs-target="#staticBackdrop"
            >
              แนบเอกสาร
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div v-if="this.Loading">
    <LoadingBs5></LoadingBs5>
  </div>

  <!-- Modal -->
  <div
    class="modal fade font-family"
    id="exampleModal"
    tabindex="-1"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title fs-4" id="exampleModalLabel"></h5>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>
        <div class="modal-body">
          <div class="icon-model">
            <img src="@/assets/images/icon-warning.svg" class="w-100" />
          </div>
          <div class="massege fw-normal text-center">
            <p class="mb-0">รายการเปลี่ยนแปลงของท่านยังไม่ได้รับ</p>
            <p class="mb-0">การบันทึก และข้อมูลที่ท่านกรอกจะถูกล้าง</p>
            <p class="mb-0 pt-lg-4">
              ท่านต้องการจะย้อนกลับไปก่อนหน้านี้ใช่หรือไม่
            </p>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-light fw-normal popup_cancel "
            data-bs-dismiss="modal"
          >
            ไม่ต้องการ
          </button>
          <router-link to="/ChangeBranch">
            <button type="button" class="btn btn-model fw-normal" data-bs-dismiss="modal" @click="ClearData()">ต้องการ</button>
          </router-link>
        </div>
      </div>
    </div>
  </div>

  <!-- Modal -->
  <div
    class="modal fade"
    id="staticBackdrop"
    data-bs-backdrop="static"
    data-bs-keyboard="false"
    tabindex="-1"
    aria-labelledby="staticBackdropLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content font-family">
        <div class="modal-header">
          <h1 class="modal-title fs-4 blue-1" id="staticBackdropLabel">
            กรุณาแนบหลักฐาน
          </h1>
          <button
            type="button"
            class="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          ></button>
        </div>
        <div class="modal-body fw-normal fs-5">
          <div class="gray-3">ท่านได้ทำการขอเปลี่ยนแปลงรายการข้อมูลดังนี้</div>
          <div class="blue-1 ms-2">
            <img
              src="@/assets/images/icon-checked.svg"
              class="mb-1 pe-1"
              style="width: 25px; border-radius: 50%; cursor: pointer"
            />ขอย้ายสาขา (ตัวแทนดำเนินการ)
          </div>
          <div>
            <label>กรุณากด</label
            ><label class="blue-1 ps-1 pe-1">"แนบไฟล์"</label
            ><label>เพื่อแนบหลักฐานการเปลี่ยนแปลงดังต่อไปนี้</label>
          </div>
          <div class="ps-2">
            <label>แนบไฟล์บันทึกการขอย้ายสาขาโดยผ่านความเห็นชอบกับผู้ที่เกี่ยวข้อง ดังนี้ <span class="required">*</span></label>
            <ul>
              <li class="ps-2 blue-1">1. หน่วยต้นสังกัดตรง</li>
              <li class="ps-2 blue-1">2. BDM ของสายงานเดิม</li>
              <li class="ps-2 blue-1">3. ผอ. ภาคของสายงานเดิม</li>
              <li v-if="this.Li === 'A'" class="ps-2 blue-1">4. ผู้บริหารส่วนพัฒนาธุรกิจสาขา และสำนักงานตัวแทน</li>
            </ul>
          </div>
          <div>
            <label
              >(ประเภทไฟล์ jpg / jpeg / png / pdf / ขนาดไม่เกิน 4 MB)</label
            >
          </div>

          <div class="shadow-none p-3 mb-1 bg-light rounded">
            <div class="text-center">
              <label class="fs-5 fw-normal">แนบไฟล์ บันทึกการขอย้ายสาขา (ตัวแทนใต้สังกัด)</label>
              <button type="button" class="border-0 bg-light" @click="FileImport($event)">
                <a class="fs-5 blue-1">แนบไฟล์</a>
              </button>
              <input type="file" ref="uploader" style="display: none" @change="onFileChange($event)"/>
            </div>

            <div v-if="this.UploadFile != null" class="row alert text-bg-success mt-1" role="alert">
              <div class="col-6 text-truncate">
                {{ File.name }}
              </div>
              <div class="col-6 text-center">Upload complete</div>
              <font-awesome-icon :icon="faCircleXmark"
                style="width: 25px; height: 30px; position: absolute; right: 3px; cursor: pointer;"
                @click="DelectFile()"
              />
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="btn btn-secondary fs-5"
            data-bs-dismiss="modal"
          >
            แก้ไข
          </button>
          <button type="button" class="btn btn-primary fs-5"  data-bs-dismiss="modal" @click="CheckEnter()">
            ส่งข้อมูล
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Menu from "@/components/agenteservice/Menu.vue";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { faCircleXmark } from "@fortawesome/free-solid-svg-icons";

import LoadingBs5 from "@/components/frontend/LoadingBs5";
import http from "@/services/AuthService";
import Swal from 'sweetalert2/src/sweetalert2.js' 

export default {
  name: "FinishAgentBranch",
  components: {
    Menu,
    FontAwesomeIcon,
    LoadingBs5
  },
  data() {
    return {
      faCircleXmark: faCircleXmark,
      Loading : false,
      UploadFile: null,
      Li: ''
    };
  },
  mounted(){
    if(this.$store.state.AgentCode == '') {
      this.$router.push('/');
    }
    
    this.Li = this.$store.state.CHANGE_OFFICE.OFFICE.substring(0, 1);
  },
  methods: {
    CheckEnter() {
      if(this.$store.state.CHANGE_OFFICE.FILE.FILE === '') { 
        Swal.fire({
          icon: 'error',
          html: '<lable class="fs-4 fw-normal font-family">กรุณาแนบไฟล์ บันทึกการขอย้ายสาขา (ตัวแทนใต้สังกัด)</lable>',
        });
      }
      else {
        this.Loading = true;
        // let AuthorizeToken = this.$cookies.get("AuthorizeToken");
        let AuthorizeToken = localStorage.getItem("AuthorizeToken");

        http.post("AgencyERequest/ManagerChangeBranch", this.$store.state.CHANGE_OFFICE, { headers: { Authorization: `Bearer ${AuthorizeToken}` }}).then((res) => { 
          if(res.status == 200) {
            this.Loading = false;
            Swal.fire({
              position: 'center',
              icon: 'success',
              title: 'ส่งข้อมูลสำเร็จ',
              showConfirmButton: false,
              timer: 1500
            }).then(() => {
              this.ResetState();

              // this.$router.push('/FinishAgentInfoView');
              this.$router.push({
                path: '/FinishAgentInfoView',
                query: { tel: '8567' }
              });
            });
          }
          else { 
            Swal.fire({
              icon: 'error',
              html: '<lable class="fs-4 fw-normal font-family">ส่งข้อมูลไม่สำเร็จ</lable>',
            });
          }
        });
      }
    },
    ClearData() { 
      this.$store.state.PASS_OFFICE.DETAIL = [];
      this.$store.state.PASS_OFFICE.OFFICE = '';
      this.$store.state.PASS_OFFICE.MEMO = '';

      this.$store.state.CHANGE_OFFICE.AGENTCODE_CHG = [];
      this.$store.state.CHANGE_OFFICE.OFFICE = '';
      this.$store.state.CHANGE_OFFICE.CHG_BY = '';
      this.$store.state.CHANGE_OFFICE.REASON_DTL = '';
      this.$store.state.CHANGE_OFFICE.FILE.FILE = '';
      this.$store.state.CHANGE_OFFICE.FILE.FILE_TYPE = '';
    },
     FileImport(e) {
      this.$refs.uploader.click();
    },
    onFileChange(e) { 
      let files = e.target.files || e.dataTransfer.files;
      if (files[0].size > 1024 * 1024 * 4) {
        Swal.fire({
          icon: 'error',
          html: '<lable class="fs-4 fw-normal font-family">กรุณาแบบไฟล์ที่มีขนาดไม่เกิน 4 MB</lable>',
        });
      }
      else if (!this.ValidateFileType(files[0].type)) {
        Swal.fire({
          icon: 'error',
          html: '<lable class="fs-4 fw-normal font-family">กรุณาแบบไฟล์ประเภท jpg / jpeg / png / pdf</lable>',
        });
      } 
      else {
        this.UploadFile = files[0];
        if (this.UploadFile != undefined || this.UploadFile != null) {
          const reader = new FileReader();
          reader.onload = () => {
            this.$store.state.CHANGE_OFFICE.FILE.FILE = reader.result.replace("data:", "").replace(/^.+,/, "");
          };
          reader.readAsDataURL(this.UploadFile);

          this.$store.state.CHANGE_OFFICE.FILE.FILE_TYPE = this.UploadFile.type;
          this.File = this.UploadFile;
        }
      }
    },
    DelectFile() {
      this.UploadFile = null;
      this.File = '';
      this.$store.state.CHANGE_OFFICE.FILE.FILE = '';
      this.$store.state.CHANGE_OFFICE.FILE.FILE_TYPE = '';
      
      this.$refs.uploader.value = null;
    },
    ResetState() { 
      this.$store.state.PASS_OFFICE.DETAIL = [];
      this.$store.state.PASS_OFFICE.OFFICE = '';
      this.$store.state.PASS_OFFICE.MEMO = '';

      this.$store.state.CHANGE_OFFICE.AGENTCODE_CHG = [];
      this.$store.state.CHANGE_OFFICE.OFFICE = '';
      this.$store.state.CHANGE_OFFICE.CHG_BY = '';
      this.$store.state.CHANGE_OFFICE.REASON_DTL = '';
      this.$store.state.CHANGE_OFFICE.FILE.FILE = '';
      this.$store.state.CHANGE_OFFICE.FILE.FILE_TYPE = '';
    },
    ValidateFileType(Type) {
      if(Type !== "image/png" && Type !== "image/jpeg" && Type !== "application/pdf" && Type !== "image/jpg") {
        this.ClearFile();
        return false;
      }
      else {
        return true;
      }
    }
  },
};
</script>

<style>
</style>